import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import HyperDX from "@hyperdx/browser";

function setCookie(name: string, value: string, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name: string) {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
}

function initializeUserTracking() {

  if (!getCookie("initial_referrer")) {
    setCookie("initial_referrer", document.referrer || "direct");
  }


  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source");
  if (!getCookie("initial_utm_source") && utmSource) {
    setCookie("initial_utm_source", utmSource);
  }


  HyperDX.setGlobalAttributes({
    initialUtmSource: getCookie("initial_utm_source"),
    initialReferrer: getCookie("initial_referrer"),
  });
}

function trackUserLocation() {

  fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => {
      HyperDX.setGlobalAttributes({ userIp: data.ip });
    })
    .catch((error) => {
      console.error("Error fetching IP:", error);
    });


  fetch("https://ipapi.co/json/")
    .then((r) => r.json())
    .then((locationData) => {
      HyperDX.setGlobalAttributes({
        city: locationData.city,
        region: locationData.region,
        country: locationData.country_name,
        postal: locationData.postal,
        org: locationData.org,
        latitude: locationData.latitude,
        longitude: locationData.longitude,
        currency: locationData.currency,
      });
    })
    .catch((error) => {
      console.error("Error fetching location data:", error);
    });
}

export const initializeHyperDX = () => {
  if (window.location.hostname === "portal.freetech.co") {
    HyperDX.init({
      apiKey: "010f76ed-e39b-4a1e-8a8f-909ee7b1f7d2",
      service: "freetech-portal",
      consoleCapture: true,
      advancedNetworkCapture: false,
    });
  } else if (window.location.hostname === "stg-portal.freetech.co") {
    HyperDX.init({
      apiKey: "010f76ed-e39b-4a1e-8a8f-909ee7b1f7d2",
      service: "freetech-portal-stg",
      consoleCapture: true,
      advancedNetworkCapture: false,
    });
  }

  HyperDX.attachToReactErrorBoundary(ErrorBoundary);
};

export default function HyperDXInitializer() {
  useEffect(() => {

    if (
      window.location.hostname === "portal.freetech.co" ||
      window.location.hostname === "stg-portal.freetech.co"
    ) {
      initializeHyperDX();

      initializeUserTracking();


      trackUserLocation();
    }
  }, []);

  return null;
}
